import { lightTheme } from '@/customTheme'
import React from 'react'

function Separator({direction = 'vertical'}: { direction?: 'vertical' | 'horizontal'}) {
  const dynamicStyles: React.CSSProperties = direction === 'vertical' ? {
    width: '1px',
    height: '16px',
  } : {
    height: '1px',
    width: '100%',
  }
  return (
    <div className="floating-inspector-button-separator" style={{ ...dynamicStyles, display: 'flex', alignItems: 'center', background: lightTheme.colors.grayScale100, borderRadius: '100px'}} />
  )
}

export default Separator